// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Scrolling Title Component - matches Hero styling exactly */
.scrolling-title {
  background-color: var(--color-secondary);
  color: var(--color-text-primary);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  position: relative;
  padding: 2rem 0;
}

.scrolling-title-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

/* Scrolling Title Text Lines */
.scrolling-title-text-line {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
}

/* Scrolling title uses global .scrolling-text class */

.scrolling-title-text {
  font-family: var(--font-family-scrolling);
  font-weight: 900;
  font-size: 8rem;
  letter-spacing: 4px;
  text-transform: uppercase;
  line-height: 1;
}

/* Component-specific letter spacing for scrolling title text */
.scrolling-title-text .solid {
  letter-spacing: 4px;
}

.scrolling-title-text .outline {
  letter-spacing: 4px;
  font-weight: 400;
}

/* Responsive Design */
@media (max-width: 1200px) {
  .scrolling-title-text {
    font-size: 6rem;
    letter-spacing: 3px;
  }

  .scrolling-title-text .solid,
  .scrolling-title-text .outline {
    letter-spacing: 3px;
  }
}

@media (max-width: 768px) {
  .scrolling-title-text {
    font-size: 4rem;
    letter-spacing: 2px;
  }

  .scrolling-title-text .solid,
  .scrolling-title-text .outline {
    letter-spacing: 2px;
  }
}

@media (max-width: 480px) {
  .scrolling-title-text {
    font-size: 3rem;
    letter-spacing: 1px;
  }

  .scrolling-title-text .solid,
  .scrolling-title-text .outline {
    letter-spacing: 1px;
  }
}

@media (max-width: 320px) {
  .scrolling-title-text {
    font-size: 3rem;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/ScrollingTitle/ScrollingTitle.css"],"names":[],"mappings":"AAAA,6DAA6D;AAC7D;EACE,wCAAwC;EACxC,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,+BAA+B;AAC/B;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,sDAAsD;;AAEtD;EACE,yCAAyC;EACzC,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA,+DAA+D;AAC/D;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;;IAEE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;;IAEE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;;IAEE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Scrolling Title Component - matches Hero styling exactly */\n.scrolling-title {\n  background-color: var(--color-secondary);\n  color: var(--color-text-primary);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  position: relative;\n  padding: 2rem 0;\n}\n\n.scrolling-title-container {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Scrolling Title Text Lines */\n.scrolling-title-text-line {\n  width: 100%;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n/* Scrolling title uses global .scrolling-text class */\n\n.scrolling-title-text {\n  font-family: var(--font-family-scrolling);\n  font-weight: 900;\n  font-size: 8rem;\n  letter-spacing: 4px;\n  text-transform: uppercase;\n  line-height: 1;\n}\n\n/* Component-specific letter spacing for scrolling title text */\n.scrolling-title-text .solid {\n  letter-spacing: 4px;\n}\n\n.scrolling-title-text .outline {\n  letter-spacing: 4px;\n  font-weight: 400;\n}\n\n/* Responsive Design */\n@media (max-width: 1200px) {\n  .scrolling-title-text {\n    font-size: 6rem;\n    letter-spacing: 3px;\n  }\n\n  .scrolling-title-text .solid,\n  .scrolling-title-text .outline {\n    letter-spacing: 3px;\n  }\n}\n\n@media (max-width: 768px) {\n  .scrolling-title-text {\n    font-size: 4rem;\n    letter-spacing: 2px;\n  }\n\n  .scrolling-title-text .solid,\n  .scrolling-title-text .outline {\n    letter-spacing: 2px;\n  }\n}\n\n@media (max-width: 480px) {\n  .scrolling-title-text {\n    font-size: 3rem;\n    letter-spacing: 1px;\n  }\n\n  .scrolling-title-text .solid,\n  .scrolling-title-text .outline {\n    letter-spacing: 1px;\n  }\n}\n\n@media (max-width: 320px) {\n  .scrolling-title-text {\n    font-size: 3rem;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
